import React, { Fragment, useState, useEffect } from 'react';
import LaunchIcon from '@material-ui/icons/Launch';
import DescriptionIcon from '@material-ui/icons/Description';
import AssignmentIcon from '@material-ui/icons/Assignment';
import AttachFileIcon from '@material-ui/icons/AttachFile';
import CloseIcon from '@material-ui/icons/Close';
import WarningIcon from '@material-ui/icons/Warning';
import Modal from '@material-ui/core/Modal';
import { Button } from 'reactstrap';
import Tooltip from '@material-ui/core/Tooltip';
import IconButton from '@material-ui/core/IconButton';
import NotesAdmission from './NotesAdmission';
import TenCorrectAdmission from './TenCorrectAdmission';
import history from '../../../../history';
import FallingRisk from './FallingRisk';
import PrintIcon from '@material-ui/icons/Print';
import AdmissionFormat from './AdmissionFormat';
import PrintModal from '../../../ClinicHistory/SearchClinicHistory/components/PrintModal';
import MonetizationOnIcon from '@material-ui/icons/MonetizationOn';
import Ballot from '@material-ui/icons/Ballot';
import ModalTheme from '../../../../shared/components/Modal';
import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline';
import ActivityVisitsPatient from '../../../ClinicHistory/ClinicHistoryViewIPS/components/ClinicalStudio/ActivityVisitsPatient';
import RadiopharmacyAdmision from './RadiopharmacyAdmision';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBiohazard, faCommentMedical, faRadiation, faCalendarAlt, faFileAlt, faUserDoctor, faSquareCheck, faEnvelope, faListCheck } from "@fortawesome/free-solid-svg-icons";
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import Brightness1Icon from '@material-ui/icons/Brightness1';
import ColorStateAdmision from './ColorStateAdmision';
import ColorStateDoctor from './ColorStateDoctor';
import PatientsCallSocket from '../../../PatientsCall/PatientsCallSocket';
import ImageSearchIcon from '@material-ui/icons/ImageSearch';
import BlockIcon from '@material-ui/icons/Block';
import KeyboardVoice from '@material-ui/icons/KeyboardVoice';
import AssignmentLate from '@material-ui/icons/AssignmentLate';
import RequestReschedule from './RequestReschedule';
import InformedConsent from './InformedConsent';
import InformedConsentNoRefund from './InformedConsentNoRefund';
import ChangeProfesionalAdmission from './ChangeProfesionalAdmission';

const ReactTableActions = ({ data, state, callbackRadioPharmacy, callbackTenCorrect, refresh, indexPageForm = 0, callbackHealthProfessional, callbackFallingRisks }) => {
  
  const [openRisk, setOpenRisk] = useState(false);
  const [openNote, setOpenNote] = useState(false);
  const [openFormat, setOpenFormat] = useState(false);
  const [openTenCorrect, setOpenTenCorrect] = useState(false);
  const [openPrintModal, setOpenPrintModal] = useState(false);
  const [openModalCloseAdmission, setOpenModalCloseAdmission] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [openActivityVisit, setOpenActivityVisit] = useState(false);
  const [openRadiopharmacyAdmision, setOpenRadiopharmacyAdmission] = useState(false);
  const [openState, setOpenState] = useState(false);
  const [openStateDoc, setOpenStateDoc] = useState(false);
  const [colorState, setColorState] = useState('#A6ADB6');
  const [colorStateDoc, setColorStateDoc] = useState('#A6ADB6');
  const [modalCancelar, setModalCancelar] = useState(false);
  const [radioPhamarcyList, setRadioPharmacyList] = useState([]);
  const [radioPharmacy, setRadioPharmacy] = useState(null);
  const [modalReagendar, setModalReagendar] = useState(false);
  const [openInformedConsent, setOpenInformedConsent] = useState(false);
  const [openInformedConsentNoRefund, setOpenInformedConsentNoRefund] = useState(false);
  const [userPermits, setUserPermits] = useState([]);
  const [validateProcedure, setValidateProcedure] = useState(false);
  const [isConsulta, setIsConsulta] = useState(false);
  const [impresionColor, setImpresionColor] = useState('#8F8F88');
  const [transcriptionData, setTranscriptionData] = useState(null);
  const [professionalChangeAdmission, setProfessionalChangeAdmission] = useState(false);
  const [modalSenderClinicHistory, setModalSenderClinicHistory] = useState(false);
  const [askFallingRisks, setAskFallingRisks] = useState(false);
  const [openModalFallingRisk, setOpenModalFallingRisk] = useState(false);
  const [idClinica] = useState(sessionStorage.getItem('id_clinica'))

  const profile = sessionStorage.getItem('perfil');
  const listTipos = JSON.parse(sessionStorage.getItem('centroTipos'));


  useEffect(() => {
    loadColors();
    validatePermissionsActionsAdmission();
    validateShowInfoClinic();
    console.log("DATAORIGINAL", data);
    validateService();
    validateImpresionsColor();
  }, []);

  const validatePermissionsActionsAdmission = () => {
    var user = JSON.parse(sessionStorage.getItem('usuario'));
    if (user != null) {
      if (user.perfil != undefined) {
        var perfil = user.perfil.modulos;
        var id_perfil = user.perfil.id_perfil;
        console.log("El perfil es: ", user.perfil.modulos)
        setUserPermits(perfil);
      } else {
        var perfil = [];
        setUserPermits(perfil);
      }
    } else {
      setUserPermits([]);
    }
  }

  //valida el servicio para mostrar o no el consentimiento informado
  const validateService = () => {
    try {
      let validateServicios = data.data.original.servicios.some(ser => ser.nombre.toUpperCase().search("GAMAGRAFIA") != -1 || !!ser.codigo ? ser.codigo.substring(0, 2) == "92" : ser.cupscod.substring(0, 2) == "92");
      let validateConsulta = data.data.original.servicios.some(ser => ser.nombre.toUpperCase().search("CONSULTA") != -1 || !!ser.codigo ? ser.codigo.substring(0, 2) == "89" : ser.cupscod.substring(0, 2) == "89");
      if (validateServicios) {
        setValidateProcedure(true);
        if (data.data.original.historia_cerrada)
          getTranscription();
      } else {
        setValidateProcedure(false);
      }
      if (validateConsulta) {
        setIsConsulta(true);
      } else {
        setIsConsulta(false);
      }
    } catch (error) {
      console.log(error, "No se pudo evaluar el servicio")
    }
  }

  const changeColorState = (value) => {
    switch (value) {
      case "1": setColorState('#D53E3E');
        break;
      case "2": setColorState('#3D8BF3');
        break;
      case "3": setColorState('#70D52F');
        break;
      case "4": setColorState('#70D52F');
        break;
      case "5": setColorState('#F2F236');
        break;
      default: setColorState('#A6ADB6');
        break;
    }
    setOpenState(false);
  }
  //setColorState - setColorStateDoc
  const changeColorStateDoc = (value) => {
    switch (value) {
      case "1": setColorStateDoc('#D16BCF');
        break;
      case "2": setColorStateDoc('#D53E3E');
        break;
      case "3": setColorStateDoc('#3D8BF3');
        break;
      case "4": setColorState('#70D52F');
        break;
      case "5": setColorState('#F2F236');
        break;
      default: setColorStateDoc('#A6ADB6');
        break;
    }

    setOpenStateDoc(false);
  }

  const closeAdmission = () => {
    //let today = new Date().toLocaleString('en-US', { timeZone: 'America/Bogota' }); 

    let today = new Date();
    var dataClose = { id_admision: data.data.original.id_admision, fecha_cierre: today };
    fetch(process.env.REACT_APP_PUBLIC_URL + 'admision/close', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'authorization': 'Bearer ' + sessionStorage.getItem('token'),
      },
      body: JSON.stringify(dataClose)
    })
      .then(response => {
        return response.json();
      })
      .then(data => {        
        setOpenModal(true);
        refresh('', false, true);
      }).catch((e) => {
        console.error(e);
      });
  }

  const cancelAdmission = () => {
    //let today = new Date().toLocaleString('en-US', { timeZone: 'America/Bogota' }); 

    let today = new Date();
    var dataCancel = { id_admision: data.data.original.id_admision, fecha_cierre: today };
    fetch(process.env.REACT_APP_PUBLIC_URL + 'admision/cancel', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'authorization': 'Bearer ' + sessionStorage.getItem('token'),
      },
      body: JSON.stringify(dataCancel)
    })
      .then(response => {
        return response.text();
      })
      .then(data => {
        //alert(data);
        console.log(data);
        refresh('', false, true);
        alert("Admisión anulada con exito");
        //setOpenModal(true);
      }).catch((e) => {
        console.log(e);
      });
  }

  const loadBilling = (id_admision) => {
    return new Promise((resolve, reject) => {
      var dataBilling = { id_admision: id_admision };
      console.log(dataBilling);
      fetch(process.env.REACT_APP_PUBLIC_URL + 'reciboscaja/admisionpaga', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'authorization': 'Bearer ' + sessionStorage.getItem('token'),
        },
        body: JSON.stringify(dataBilling)
      })
        .then(response => {
          return response.json();
        })
        .then(data => {

          resolve(data.contenido[0]);

        }).catch((e) => {
          console.log(e);
          reject(e);
        });
    })
  }

  const loadFatherAdmission = (id_admision_padre) => {
    return new Promise((resolve, reject) => {
      var dataFatherAdmision = { id_admision: parseInt(id_admision_padre) };
      fetch(process.env.REACT_APP_PUBLIC_URL + 'admision/consultar', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'authorization': 'Bearer ' + sessionStorage.getItem('token'),
        },
        body: JSON.stringify(dataFatherAdmision)
      }).then(response => {
        return response.json();
      }).then(data => {
        resolve(data.contenido[0]);
      }).catch((e) => {
        reject(e);
      });
    });
  }

  const loadPlan = (billing, dataAdmision) => {
    var dataClose = { id_plan: billing.id_plan };
    fetch(process.env.REACT_APP_PUBLIC_URL + 'plan/consultar_plan', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'authorization': 'Bearer ' + sessionStorage.getItem('token'),
      },
      body: JSON.stringify(dataClose)
    })
      .then(response => {
        return response.json();
      })
      .then(data => {
        loadDataProfile(billing, data.contenido[0], dataAdmision);
      }).catch((e) => {
        console.log(e);
      });
  }

  const loadDataProfile = (billing, plan, dataAdmision) => {
    fetch(process.env.REACT_APP_PUBLIC_URL + 'clinica/listar', {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'authorization': 'Bearer ' + sessionStorage.getItem('token'),
      }
    })
      .then(response => {
        return response.json();
      })
      .then(resp => {
        console.log(resp);
        if (resp.length > 0) {
          history.push({
            pathname: process.env.PUBLIC_URL + '/assitencial/receipt-admission',
            state: {
              dataPatient: dataAdmision,
              dataCashReceipt: billing,
              dataPlan: plan,
              dataProfile: resp[0],
              state: state,
              datePrevious: data.data.original.fecha,
              indexPage: indexPageForm
            }
          });
        }
      })
      .catch((error) => {
        console.error('Error:', error);
      });
  }

  const loadRadioPharmacy = async () => {
    await fetch(process.env.REACT_APP_PUBLIC_URL + 'admision-radiofarmaco/listar-por-admision?id_admision=' + data.data.original.id_admision, {
      method: 'GET',
      headers: {
        'authorization': 'Bearer ' + sessionStorage.getItem('token'),
      }
    }).then((response) => {
      return response.json();
    }).then(response => {
      //Por ahora solo 1 farmaco
      if (response[0] !== undefined && response[0] !== null) {
        setRadioPharmacyList(response);
        setRadioPharmacy(response[0]);
      }
      else {
        setRadioPharmacyList([]);
        setRadioPharmacy(null);
      }
      setOpenRadiopharmacyAdmission(true);
    }).catch((err) => {
      setRadioPharmacyList([]);
      setRadioPharmacy(null);
      setOpenRadiopharmacyAdmission(true);
    });
  }

  const loadColors = () => {
    //Estado Doctor
    if (data.data.original.estado_medico != null && data.data.original.estado_medico != undefined) {
      changeColorStateDoc(data.data.original.estado_medico.toString());
    }
    else {
      changeColorStateDoc(null);
    }

    //Estado Imagenes 
    if (data.data.original.estado_imagenes != null && data.data.original.estado_imagenes != undefined) {
      changeColorState(data.data.original.estado_imagenes.toString());
    }
    else {
      changeColorState(null);
    }
  }

  const callPatientInWaitingRoom = async () => {
    await PatientsCallSocket.callPacient(data.data.original).then((res) => {
      if (res == false) {
        PatientsCallSocket.joinPatient(data.data.original);
      }
      else {
        alert("El paciente de esta admisión ya fue llamado en la Sala de Espera");
      }
    }).catch((err) => {
      console.log(err);
    });
  }

  const loadImagingFile = () => {
    history.push({
      pathname: process.env.PUBLIC_URL + '/assitencial/upload-diagnostic-images',
      state: { dataPatient: data.data.original }
    });
  }

  const requestRescheduling = () => {
    setModalReagendar(true);
  }

  const validateShowInfoClinic = () => {
    let clinica = JSON.parse(sessionStorage.getItem('clinica'));
    setAskFallingRisks(clinica.hasOwnProperty('solicitar_riesdo_caida') ? clinica.solicitar_riesdo_caida : false)
  }

  //Abre el Recibo de Caja Original
  const validateBilling = async () => {
    /* if (data.data.original.id_admision_cita_padre != null && data.data.original.id_admision_cita_padre != undefined) {
      let fatherAdmission = await loadFatherAdmission(data.data.original.id_admision_cita_padre);
      await loadBilling(fatherAdmission.id_admision).then((billing) => {
        if (typeof billing === 'string') {
          history.push({
            pathname: process.env.PUBLIC_URL + '/assitencial/receipt-admission',
            state: {
              dataPatient: fatherAdmission,
              dataCashReceipt: null,
              dataPlan: null,
              dataProfile: null,
              state: state,
              datePrevious: data.data.original.fecha,
              indexPage: indexPageForm
            }
          });
        }
        else {
          loadPlan(billing, fatherAdmission);
        }
      }).catch((e) => {
        console.log(e);
      });
    } */
      await loadBilling(data.data.original.id_admision).then((billing) => {
        if (typeof billing === 'string') {
          history.push({
            pathname: process.env.PUBLIC_URL + '/assitencial/receipt-admission',
            state: {
              dataPatient: data.data.original,
              dataCashReceipt: null,
              dataPlan: null,
              dataProfile: null,
              state: state,
              datePrevious: data.data.original.fecha,
              indexPage: indexPageForm
            }
          });
        }
        else {
          loadPlan(billing, data.data.original);
        }
      }).catch((e) => {
        console.log(e);
      });
    
  }

  const validateImpresionsColor = () => {

    if (data.data.original.pertenece_estudio == false) {
      if (isConsulta !== true && validateProcedure !== true) {
        if (data.data.original.servicios[0].codigo === "895001") {
          if (data.data.original.otros_procedimientos.holter === true) {
            setImpresionColor('green');
          }
        } else if (data.data.original.servicios[0].codigo === "891234" || data.data.original.servicios[0].codigo === "881233" || data.data.original.servicios[0].codigo === "881202") {
          if (data.data.original.otros_procedimientos.eco === true) {
            setImpresionColor('green');
          }
        } else if (data.data.original.servicios[0].codigo === "895100") {
          if (data.data.original.otros_procedimientos.ekg === true) {
            setImpresionColor('green');
          }
        } else if (data.data.original.servicios[0].codigo === "896100" || data.data.original.servicios[0].codigo === "896101" || data.data.original.servicios[0].codigo === "895004") {
          if (data.data.original.otros_procedimientos.mapa === true) {
            setImpresionColor('green');
          }
        }
      }
    }
    else {
      setImpresionColor('#8F8F88');
    }
  }

  const getTranscription = async () => {
    let id_admision = parseInt(data.data.original.id_admision);
    await fetch(process.env.REACT_APP_PUBLIC_URL + 'admision-transcripcion/consultar?id_admision=' + id_admision, {
      method: 'GET',
      headers: {
        'authorization': 'Bearer ' + sessionStorage.getItem('token'),
      }
    }).then(response => {
      if (response.status != 500 && response.status != 403) {
        return response.json();
      }
      else {
        throw new Error("Ha ocurrido un error");
      }
    }).then(res => {
      if (res.transcripcion != null && res.transcripcion != undefined) {
        setTranscriptionData(res.transcripcion);
        setImpresionColor('green')
      }
    }).catch(error => {
      console.log(error);
      setTranscriptionData(null);
      setImpresionColor('#8F8F88')
    });
  }

  return (
    <Fragment>
      <td role="cell">
        {/* {profile === '9' || profile === '16' || profile === '10' || profile === '17' || profile === '11' ?
          listTipos.includes('3') ?
            <Tooltip title="Estado del Tecnologo">
              <IconButton aria-label="launch" color="inherit" style={{ padding: 2, backgroundColor: colorState }}
                onClick={() => {

                  if (profile === '9' || profile === '16')
                    setOpenState(true);
                }}
              >
                <Brightness1Icon style={{ color: colorState }} />
              </IconButton>
            </Tooltip>
            : null
          : null}

        {profile === '9' || profile === '16' || profile === '10' || profile === '17' || profile === '11' ?
          listTipos.includes('3') ?
            <Tooltip title="Estado del Medico">
              <IconButton aria-label="launch" color="inherit" style={{ padding: 2, backgroundColor: colorStateDoc }}
                onClick={() => {
                  if (profile === '10' || profile === '9')
                    setOpenStateDoc(true);
                }}
              >
                <Brightness1Icon style={{ color: colorStateDoc }} />
              </IconButton>
            </Tooltip>
            : null
          : null} */}


        {profile === '9' || profile === '11' || profile === '19' || userPermits.includes(3) ?
          <Tooltip title="Llamar al paciente">
            <IconButton aria-label="launch" style={{ padding: 2 }}
              onClick={() => {
                callPatientInWaitingRoom();
              }}
            >
              <FontAwesomeIcon icon={faCommentMedical} style={{ color: '#70bbfd' }} />
            </IconButton>
          </Tooltip>
          : null}

        {profile === '9' || profile === '11' || profile === '16' || profile === '19' || userPermits.includes(3) ?
          <Tooltip title="ver admisión y egreso del paciente">
            <IconButton aria-label="launch" style={{ padding: 2 }}
              onClick={() => {
                history.push({
                  pathname: process.env.PUBLIC_URL + '/assitencial/add-admission',
                  state: {
                    caidas: data.data.original.caidas,
                    dataPatient: data.data.original,
                    id_admision: data.data.original.id_admision,
                    recibo_pago: data.data.original.pago,
                    indexPage: indexPageForm
                  }
                });
              }}
            >
              <LaunchIcon style={{ color: '#000' }} />
            </IconButton>
          </Tooltip>
          : null}

        {profile === '9' || profile === '11' || profile === '19' || userPermits.includes(3) ?
          <Tooltip title="Impresiones">
            <IconButton aria-label="launch"
              style={{ padding: 2 }}
              onClick={() => {
                setOpenPrintModal(true);
              }}>
              <PrintIcon style={{ color: impresionColor }} />
            </IconButton>
          </Tooltip>
          : null}

        {userPermits.includes(57) ?
          <Tooltip title="10 correctos">
            <IconButton
              aria-label="ten-corrects"
              style={{ padding: 2 }}
              onClick={() => {
                setOpenTenCorrect(!openTenCorrect);
              }}
            >
              <AssignmentIcon style={{ color: data.data.original.correctos != null ? 'green' : '#4A3C1A' }} />
            </IconButton>
          </Tooltip>
          : null}

        {askFallingRisks && userPermits.includes(59) ?
          <Tooltip title="Riesgo de Caida">
            <IconButton
              aria-label="falling-risk"
              style={{ padding: 2 }}
              onClick={() => {
                setOpenModalFallingRisk(true);
              }}
            >
              <FontAwesomeIcon icon={faListCheck} style={{ width: '0.8em', height: '0.8em', color: data.data.original.caidas.hasOwnProperty('riesgo') ? data.data.original.caidas.riesgo !== '' ? 'green' : '#4A3C1A' : '#4A3C1A' }} />
            </IconButton>
          </Tooltip>
          : null}

        {profile === '9' || profile === '16' || profile === '11' || profile === '19' || userPermits.includes(3) ?
          <Tooltip title="Observaciones">
            <IconButton
              aria-label="observations"
              style={{ padding: 2 }}
              onClick={() => {
                setOpenNote(!openNote);
              }}
            >
              <DescriptionIcon style={{ color: '#A8ADC2' }} />
            </IconButton>
          </Tooltip>
          : null}

        {profile === '9' || profile === '16' || profile === '11' || profile === '19' || userPermits.includes(3) ?
          <Tooltip title="Agregar archivo">
            <IconButton
              aria-label="attach-file"
              style={{ padding: 2 }}
              onClick={() => {
                //sessionStorage.setItem('searchAdmisionState', this.state); 
                history.push({
                  pathname: process.env.PUBLIC_URL + '/assitencial/files-admission',
                  state: {
                    dataPatient: data.data.original,
                    indexPage: indexPageForm
                  }
                });
              }}
            >
              <AttachFileIcon style={{ color: '#888888' }} />
            </IconButton>
          </Tooltip>
          : null}

        {/* {profile === '9' || profile === '16' || profile === '17' || profile === '11' ?
          listTipos.includes('3') ?
            <Tooltip title="Entrevista">
              <IconButton
                aria-label="add"
                style={{ padding: 2 }}
                onClick={() => {
                  history.push({
                    pathname: process.env.PUBLIC_URL + '/assitencial/interview',
                    state: { dataPatient: data.data.original, radioFarmacia: radioPharmacy }
                  });
                }}
              >
                <AddCircleOutlineIcon style={{ color: data.data.original.entrevista_realizada === true ? 'green' : '#70bbfd' }} />
              </IconButton>
            </Tooltip>
            : null
          : null} */}

        {
          validateProcedure ? <>
            <Tooltip title="Consentimiento Informado">
              <IconButton aria-label="launch"
                style={{ padding: 2 }}
                onClick={() => {
                  setOpenInformedConsent(true);
                }}>
                {<FontAwesomeIcon icon={faFileAlt} style={{ color: data.data.original.consentimiento_informado_validado == true ? 'green' : '#000' }} />}
              </IconButton>
            </Tooltip>
          </>
            : null
        }

        {
          data.data.original.regimen_admision != null && data.data.original.regimen_admision != undefined ?
            <>
              {
                data.data.original.regimen_admision.toUpperCase() === "PARTICULAR" ? <Tooltip title="Formato de No Reembolso">
                  <IconButton
                    aria-label="attach-file"
                    style={{ padding: 2 }}
                    onClick={() => {
                      setOpenInformedConsentNoRefund(true);
                    }}
                  >
                    <AssignmentLate style={{ color: data.data.original.consentimiento_no_reembolso != null && data.data.original.consentimiento_no_reembolso != undefined ? 'green' : '#000' }} />
                  </IconButton>
                </Tooltip> : null
              }
            </> : null
        }

        {(profile === '9' || profile === '11' || profile === '19' || userPermits.includes(20)) && data.data.original.pertenece_estudio != true ?
          <Tooltip title="Recibo de Caja">
            <IconButton
              aria-label="bill"
              style={{ padding: 2 }}
              onClick={() => {
                validateBilling();
              }}
            >
              <MonetizationOnIcon style={{
                color: data.data.original.pago === true && data.data.original.id_factura_t !== null ? 'green' :
                  data.data.original.pago === true ? 'blue' :
                    '#000'
              }} />
            </IconButton>
          </Tooltip>
          : null}

        {profile === '9' || profile === '19' ?
          data.data.original.id_visita != null ? <Tooltip title="Check de Visita">
            <IconButton
              aria-label="attach-file"
              disabled={data.data.original.id_estudio_paciente == null ? true : false}
              onClick={() => {
                setOpenActivityVisit(true);
              }}
            >
              <FontAwesomeIcon icon={faSquareCheck}
                style={{
                  padding: 2,
                  color:
                    data.data.original.id_estudio_paciente != null && data.data.original.actividades_realizadas == true ? "green" :
                      data.data.original.id_estudio_paciente == null && data.data.original.actividades_realizadas == true ? "aed6ae" :
                        data.data.original.id_estudio_paciente != null && data.data.original.actividades_realizadas == false ? "black" :
                          "#9c9c9c"
                }} />
            </IconButton>
          </Tooltip> : null
          : null}


        {/*  {profile === '9' || profile === '16' ?
          listTipos.includes('3') ?
            <Tooltip title="Registrar Radiofarmaco">
              <IconButton
                aria-label="activity-visit"
                style={{ padding: 2 }}
                onClick={() => {
                  loadRadioPharmacy();
                }}
              >
                <FontAwesomeIcon icon={faBiohazard} style={{ color: data.data.original.radiofarmaco_aplicado === true ? 'green' : 'black' }} />
              </IconButton>
            </Tooltip>
            : null
          : null} */}

        {/* {listTipos.includes('3') ?  <Tooltip title="Subir Imagenes Diagnosticas">
            <IconButton
              aria-label="activity-visit"
              style={{ padding: 2 }}
              onClick={() => {
                loadImagingFile();
              }}
            >
              <FontAwesomeIcon icon={faRadiation} style={{ color: data.data.original.existen_imagenes_diagnosticas === true ? 'green' : 'black' }} />
            </IconButton>
          </Tooltip> : null} */}

        {profile === '16' ?

          <Tooltip title="Historia Clinica">
            <IconButton aria-label="launch"
              style={{ padding: 2 }}
              onClick={() => {
                history.push({
                  pathname: process.env.PUBLIC_URL + '/assitencial/clinic-history3',
                  state: { data: data.data.original }
                });
              }}>
              <ImageSearchIcon style={{ color: '#000' }} />
            </IconButton>
          </Tooltip>
          : null}

        {/* {(profile === '9' || profile === '19') || userPermits.includes(39) ? */}
        {profile === '9' || profile === '19' ?
          <Tooltip title="Anular Admision">
            <IconButton aria-label="launch" style={{ padding: 2 }}
              onClick={() => {
                setModalCancelar(true);
              }}
            >
              <BlockIcon style={{ color: '#C20D0D' }} />
            </IconButton>
          </Tooltip>
          : null}

        {(profile === '9' || profile === '19') || userPermits.includes(39) ?
          <Tooltip title="Cerrar admisión">
            <IconButton
              aria-label="attach-file"
              style={{ padding: 2 }}
              onClick={() => {
                setOpenModalCloseAdmission(!openModalCloseAdmission);
              }}
            >
              <CloseIcon style={{ color: '#000' }} />
            </IconButton>
          </Tooltip>
          : null}

        {/* {
          data.data.original.pertenece_estudio != true ? <Tooltip title="Reagendar Admisión">
            <IconButton
              aria-label="attach-file"
              style={{ padding: 2 }}
              onClick={() => {
                requestRescheduling();
              }}
            >
              <FontAwesomeIcon icon={faCalendarAlt} style={{ color: '#000' }} />
            </IconButton>
          </Tooltip> : null
        } */}

        {
          userPermits.includes(53) ? <>
            {
              data.data.original.honorario_medico != true ? <Tooltip title="Cambiar Profesional en Salud">
                <IconButton
                  aria-label="attach-file"
                  style={{ padding: 2 }}
                  onClick={() => {
                    setProfessionalChangeAdmission(true);
                  }}
                >
                  <FontAwesomeIcon icon={faUserDoctor} style={{ color: '#000' }} />
                </IconButton>
              </Tooltip> : null
            }
          </> : null
        }

        {/*
        <Tooltip title="Enviar Historia Clinica por Correo Electronico">
          <IconButton
            aria-label="attach-file"
            style={{ padding: 2 }}
            onClick={() => {
              setModalSenderClinicHistory(true);
            }}
          >
            <FontAwesomeIcon icon={faEnvelope} style={{ color: '#000' }} />
          </IconButton>
        </Tooltip>*/}

      </td>

      {openState ? <ColorStateAdmision admision={data.data.original} openState={openState} setOpenState={setOpenState} changeColorState={changeColorState} /> : null}
      {openStateDoc ? <ColorStateDoctor admision={data.data.original} openStateDoc={openStateDoc} setOpenStateDoc={setOpenStateDoc} changeColorStateDoc={changeColorStateDoc} /> : null}
      {openNote ? <NotesAdmission data={data.data} openNote={openNote} setOpenNote={setOpenNote} /> : null}
      {openTenCorrect ? <TenCorrectAdmission data={data.data} openTenCorrect={openTenCorrect} setOpenTenCorrect={setOpenTenCorrect} callbackTenCorrect={callbackTenCorrect} /> : null}
      {openModalFallingRisk ? <FallingRisk data={data.data.original} openRisk={openModalFallingRisk} setOpenRisk={setOpenModalFallingRisk} callbackFallingRisks={callbackFallingRisks} /> : null}
      {openPrintModal ? <PrintModal data={data.data.original} openPrintModal={openPrintModal} setOpenPrintModal={setOpenPrintModal} /> : null}
      {openFormat ? <AdmissionFormat data={data.data} openFormat={openFormat} setOpenFormat={setOpenFormat} /> : null}
      {openModalCloseAdmission ?
        <Modal
          open={openModalCloseAdmission}
          onClose={e => {
            setOpenModalCloseAdmission(false)
          }}
          aria-labelledby="simple-modal-title"
          aria-describedby="simple-modal-description"
          style={{ zIndex: 1000 }}
        >
          <div className="paperAppointment-flex" style={{ width: '100%', margin: 10, width: 350 }}>
            <div style={{ flex: 'flex-end' }}>
              <CloseIcon
                onClick={() => {
                  setOpenModalCloseAdmission(!openModalCloseAdmission);
                }}
              />
            </div>
            <div style={{ textAlign: 'center' }}> ¿ Esta seguro que desea cerrar esta admisión N° {data.data.original.id_admision} ? </div>
            <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
              <Button
                style={{ marginTop: 10 }}
                color="primary"
                onClick={() => {
                  closeAdmission();
                }}
              >
                Cerrar Admisión
              </Button>
            </div>
          </div>
        </Modal> : null}
      {openActivityVisit ?
        <ActivityVisitsPatient
          data={data.data.original}
          enableLucnhAndTransport={true}
          enableActivitiesList={true}
          closeOpenActivityVisit={() => setOpenActivityVisit(false)}
          opened={openActivityVisit}
          id_estudio_paciente={data.data.original.id_estudio_paciente}
        />

        : null}
      {openRadiopharmacyAdmision ?
        <RadiopharmacyAdmision
          data={data.data} opened={openRadiopharmacyAdmision}
          closeMedicineAdmision={() => setOpenRadiopharmacyAdmission(false)}
          radioPharmacy={radioPharmacy}
          callbackRadioPharmacy={callbackRadioPharmacy}
        /> : null}
      {
        openInformedConsent ? <InformedConsent data={data.data.original} opened={openInformedConsent} closeModalInformedConsent={() => setOpenInformedConsent(false)} /> : null
      }

      {
        openInformedConsentNoRefund ? <InformedConsentNoRefund data={data.data.original} opened={openInformedConsentNoRefund} closeModal={() => setOpenInformedConsentNoRefund(false)} /> : null
      }

      {modalReagendar ?
        <RequestReschedule
          opened={modalReagendar}
          closeModal={() => setModalReagendar(false)}
          motivo_reagendamiento={data.data.motivo_reagendamiento}
          id_admision={data.data.original.id_admision}
        /> : null}

      <ModalTheme
        color={'success'}
        title={'Admision cerrada con exito'}
        modal={openModal}
        onOk={() => {
          setOpenModal(!openModal);
          setOpenModalCloseAdmission(false);
        }}
        toggle={() => { setOpenModal(!openModal) }}
      >
      </ModalTheme>

      <ModalTheme
        color={'danger'}
        title={'¿Estas seguro que deseas anular esta Admision?'}
        modal={modalCancelar}
        onOk={() => {
          setModalCancelar(!modalCancelar)
          cancelAdmission();
          //setOpenModalCloseAdmission(false);
        }}
        toggle={() => { setModalCancelar(!modalCancelar) }}
      >
      </ModalTheme>

      <ChangeProfesionalAdmission
        opened={professionalChangeAdmission}
        closeModal={() => setProfessionalChangeAdmission(false)}
        data={data.data.original}
        callbackHealthProfessional={(id_admision, profesionalData) => callbackHealthProfessional(id_admision, profesionalData)}
      />
    </Fragment>)
}

export default ReactTableActions;
